import React, { useEffect, useRef, useState } from "react";
import styles from "./ArticleContent.module.css";
import ArticleList from "../ArticleList/ArticleList";
import ArticleDetails from "../ArticleDetails/ArticleDetails";
import { useQuery } from "hooks/useQuery";
import { useTranslation } from "react-i18next";
import { articleListingService } from "services";

export const DataPerPage = 20;

const ArticleContent = ({ allTags, defaultTag, path, allLabel }) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  const { t } = useTranslation();
  const query = useQuery();
  const categoryQuery = query.get("category");
  const articlesRef = useRef<HTMLDivElement>(null);
  const componentDidMount = useRef<boolean>(false);
  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(1);
  const [title, setTitle] = useState({ name: "", key: "" });

  const titleDefaultState = {
    name: allLabel,
    key: "All Articles",
  };

  const setParams = (key: string, value: string) => {
    if (window.history.pushState) {
      let params = new URLSearchParams(window.location.search);
      params.set(key, value);
      let newUrl =
        window.location.origin + window.location.pathname + value
          ? "?" + params.toString()
          : "";
      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  };

  const getResultOnTitleChange = async (category: string) => {
    try {
      setParams("category", category);
      const responseData = await articleListingService(
        path,
        (pageNumber - 1) * DataPerPage,
        category
      );
      setTotalCount(responseData.resultTotal);
      setPageNumber(1);
      setData(responseData.results);
    } catch (error) {
      console.log(error);
    }
  };

  const getResultOnPageChange = async (category: string) => {
    try {
      setParams("category", category);
      const responseData = await articleListingService(
        path,
        (pageNumber - 1) * DataPerPage,
        category
      );
      setTotalCount(responseData.resultTotal);
      setData(responseData.results);
    } catch (error) {
      console.log(error);
    }
  };

  // scroll up to the first entry of the page
  // but not on the first render, only on page change
  useEffect(() => {
    if (componentDidMount.current) {
      if (articlesRef.current) {
        articlesRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    } else componentDidMount.current = true;
  }, [data]);

  useEffect(() => {
    if (categoryQuery?.length && categoryQuery !== "All Articles") {
      const titleNames = allTags?.tags?.map((tag) =>
        tag.tags.find((tag) => tag.key === categoryQuery)
      );
      const titleName = titleNames.find(
        (tag) => tag?.value.length && tag?.value !== undefined
      );
      setTitle(
        !!titleName
          ? { name: titleName.value, key: categoryQuery }
          : titleDefaultState
      );
    } else if (
      !categoryQuery &&
      defaultTag?.value?.length &&
      defaultTag?.key?.length
    ) {
      setTitle({ name: defaultTag.value, key: defaultTag.key });
    } else {
      setTitle(titleDefaultState);
    }
  }, [categoryQuery, defaultTag]);

  useEffect(() => {
    if (title.name && title.key) {
      getResultOnTitleChange(title.key);
    }
  }, [title]);

  useEffect(() => {
    if (title.name && title.key) {
      getResultOnPageChange(title.key);
    }
  }, [pageNumber]);

  return (
    <div className={styles.container}>
      <ArticleList
        allTags={allTags}
        title={title}
        setTitle={setTitle}
        allLabel={allLabel}
      />
      <ArticleDetails
        ref={articlesRef}
        data={data}
        title={title}
        setTitle={setTitle}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        totalCount={totalCount}
      />
    </div>
  );
};

export default ArticleContent;
